import React from 'react'
import DashboardIndex from './AgentDashboard'

const AgentIndex = () => {
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>Agent Dashboard</PageTitle> */}
      <DashboardIndex />
    </>
  )
}

export default AgentIndex
